<div fxLayout="column" class="position-info" fxLayoutAlign="center center" (onclick)="onClick()">
<div class="title">{{experience.positionTitle}}</div>
<div>{{experience.employer.name}}</div>
<img class="employer-logo" (click)="onClick()" [src]="experience.employer.imageUrl"/>
<div>{{experience.tenure}}</div>
</div>
